import { render, staticRenderFns } from "./OrderStatusChangeModal.vue?vue&type=template&id=11422005&scoped=true&"
import script from "./OrderStatusChangeModal.vue?vue&type=script&lang=js&"
export * from "./OrderStatusChangeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11422005",
  null
  
)

export default component.exports